import React from 'react';
import PropTypes from 'prop-types';
import { localiseUrlII } from 'src/common/utils/format-localised-url';
import { useCountry } from 'src/client/js/view/hooks';
import './FooterLinks.scss';

const FooterLinks = props => {
  const countryModel = useCountry();
  return (
    <nav className="LinksNav">
      {props.links.items.map((item, idx) => (
        <li key={idx}>
          <a
            href={localiseUrlII(countryModel, item.linkUrl)}
            className="LinksNav__link">
            <span className="LinksNav__link-text">
              {item.linkText}
            </span>
          </a>
        </li>
      ))}
    </nav>
  );
};

FooterLinks.propTypes = {
  links: PropTypes.object.isRequired,
};

export default FooterLinks;
